export default __webpack_public_path__ + "static/media/delete-new-icon.e63c4c81.svg";